import React, { useEffect, useState } from 'react'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import PassimPlayer from '../rosemary/passimPlayer'
import CustomImage from '../../customImage/customImage'
import ProfileMediaArrow from '../imgComponents/profileMediaArrow'

const VerticalStreamDeck = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  onDelete,
  onSwap,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const [activeTab, setActiveTab] = useState(1)
  const {
    customNavigate,
    CONTENT_FILTER_XAVIER,
    getTemplateImage,
    VideoPlaceholder,
    SquareDummyImg,
    playerPageAllowed,
  } = useTemplateHook()
  const [contentDataTab1, setContentDataTab1] = useState([])
  const [contentDataTab2, setContentDataTab2] = useState([])
  const [activeTabData, setActiveTabData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [{ data: contentListTab1 }, contentListCallTab1] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: contentListTab2 }, contentListCallTab2] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const getFilterPayload = (tabData) => {
    return tabData?.type === 'STATIC'
      ? { content_ids: tabData?.content_data }
      : {
          system_defined: tabData?.auto_payload.filter((info) => info.type === 'system_defined'),
          custom_defined: tabData?.auto_payload.filter((info) => info.type === 'custom_defined'),
          video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
        }
  }

  useEffect(() => {
    setActiveTabData(activeTab === 1 ? [...contentDataTab1] : [...contentDataTab2])
  }, [contentDataTab1, contentDataTab2, activeTab])

  useEffect(() => {
    if (!isEmpty(data?.tab_section1?.content_data) || !isEmpty(data?.tab_section1?.auto_payload)) {
      let filterPayload = getFilterPayload(data?.tab_section1)

      contentListCallTab1({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data?.tab_section1?.type === 'STATIC'
              ? ''
              : data?.tab_section1?.order_by === 'title'
              ? `title.${language}`
              : data?.tab_section1?.order_by,
          reverse: data?.tab_section1?.type === 'STATIC' ? '' : data?.tab_section1?.reverse,
          page_size: 25,
        },
      })
    } else {
      setContentDataTab1([])
    }
  }, [data])

  useEffect(() => {
    if (contentListTab1 && contentListTab1.success) {
      if (data.type === 'STATIC') {
        contentListTab1?.data.sort((a, b) => {
          let sortingArr = data.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      setContentDataTab1(contentListTab1.data)
    }
  }, [contentListTab1])

  useEffect(() => {
    if (!isEmpty(data?.tab_section2?.content_data) || !isEmpty(data?.tab_section2?.auto_payload)) {
      let filterPayload = getFilterPayload(data?.tab_section2)

      contentListCallTab2({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data?.tab_section2?.type === 'STATIC'
              ? ''
              : data?.tab_section2?.order_by === 'title'
              ? `title.${language}`
              : data?.tab_section2?.order_by,
          reverse: data?.tab_section2?.type === 'STATIC' ? '' : data?.tab_section1?.reverse,
          page_size: 25,
        },
      })
    } else {
      setContentDataTab2([])
    }
  }, [data])

  useEffect(() => {
    if (contentListTab2 && contentListTab2.success) {
      if (data.type === 'STATIC') {
        contentListTab2?.data.sort((a, b) => {
          let sortingArr = data.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      setContentDataTab2(contentListTab2.data)
    }
  }, [contentListTab2])

  const handleHoverItems = (name) => {
    // if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const getLink = (info) => {
    if (info.video_type === 'PLAYLIST' || info.audio_type === 'PLAYLIST') {
      return `/playlist/${info.content_id}`
    }
    if (info.video_type === 'MPVP' || info.audio_type === 'MPAP') {
      return `/parent-content/${info.content_id}`
    } else {
      if ((playerPageAllowed && info.video_type === 'MPVC') || info.audio_type === 'MPAC') {
        return `/series-watch/${info?.content_id}`
      }
      return `/content/${info.content_id}`
    }
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'} relative py-[16px] lg:py-8 `}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onEdit={() => handleModal()}
          onDelete={() => onDelete(id)}
          onCopy={() => onCopy(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}
      <div
        style={{
          paddingLeft: '3.66032%',
          paddingRight: '3.66032%',
        }}
        className="w-full flex justify-center items-center"
      >
        <div className="w-full flex flex-col xl:flex-row xl:justify-between">
          <div className="w-full xl:w-[64.5%]">
            <p
              style={{ color: getStyleValue('header_section', 'heading_color', '#fff') }}
              className="xl:text-2xl md:text-xl text-xs font-semibold mb-0"
            >
              {data?.heading}
            </p>
            <div className="flex mt-3 lg:mt-4">
              {[...data?.category_options].map((item, index) => (
                <p
                  style={{
                    marginBlockEnd: '0',
                    background: getStyleValue('header_section', 'category_bg_color', '#d6ff05'),
                    color: getStyleValue('header_section', 'category_color', '#010101'),
                    padding: '2px 8px',
                    marginLeft: index ? '15px' : '',
                  }}
                  className="text-[10px] font-semibold md:text-xs line-clamp-1 cursor-pointer mb-0"
                  onClick={() => handleRedirect(item.link)}
                  key={index}
                >
                  {item.text}
                </p>
              ))}
            </div>

            <div style={{ aspectRatio: '1.7777' }} className="w-full mt-3 relative ">
              {isEdit || isEmpty(data?.player?.data) ? (
                <div className="w-full h-full relative flex justify-center items-center">
                  <CustomImage
                    imageUrl={getTemplateImage(data?.image_s3key)}
                    imgClass="w-full h-full"
                    loaderClass="w-full h-full"
                    loaderStyle={{ background: '#5A5A5A50' }}
                    imgAlt={'recent story Img'}
                    errorPlaceholder={VideoPlaceholder}
                  />
                </div>
              ) : (
                <div className="w-full h-full">
                  <PassimPlayer
                    data={data?.player}
                    poster={getTemplateImage(data?.image_s3key)}
                    onClickRedirect={() => {}}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="w-full xl:w-[34%] mt-4 xl:mt-0 flex flex-col justify-end">
            <div className="xl:h-[80px]"></div>
            <div className="w-full xl:h-[calc(100%-80px)]">
              <div className="w-full flex items-center font-semibold">
                <div
                  className="flex justify-center items-center w-1/2 relative cursor-pointer"
                  onClick={() => setActiveTab(1)}
                >
                  <ProfileMediaArrow
                    color={
                      activeTab === 1
                        ? getStyleValue('content_section', 'tab_bg_active', '#fc0001')
                        : getStyleValue('content_section', 'tab_bg_inactive', '#fefefe')
                    }
                    imgStyle={{ width: '100%' }}
                  />
                  <p
                    style={{
                      color:
                        activeTab === 1
                          ? getStyleValue('content_section', 'tab_text_active', '#ffffff')
                          : getStyleValue('content_section', 'tab_text_inactive', '#000000'),
                    }}
                    className="absolute text-sm xl:text-base mb-0"
                  >
                    {data.tab_section1.name}
                  </p>
                </div>
                <div
                  className="flex justify-center items-center w-1/2 relative cursor-pointer"
                  onClick={() => setActiveTab(2)}
                >
                  <ProfileMediaArrow
                    color={
                      activeTab === 2
                        ? getStyleValue('content_section', 'tab_bg_active', '#fc0001')
                        : getStyleValue('content_section', 'tab_bg_inactive', '#fefefe')
                    }
                    imgStyle={{ width: '100%' }}
                  />
                  <p
                    style={{
                      color:
                        activeTab === 2
                          ? getStyleValue('content_section', 'tab_text_active', '#ffffff')
                          : getStyleValue('content_section', 'tab_text_inactive', '#000000'),
                    }}
                    className="absolute text-sm xl:text-base mb-0"
                  >
                    {data.tab_section2.name}
                  </p>
                </div>
              </div>
              <div
                style={{ marginTop: '2%' }}
                className="w-full h-[69.23vw] md:h-[40vw] xl:h-[29.5vw] 2xl:h-[30vw] hidden-scrollbar-class overflow-hidden"
              >
                {!isEmpty(activeTabData)
                  ? activeTabData.map((item, index) => {
                      return (
                        <div
                          className={`flex justify-between w-full ${index && 'mt-3'}`}
                          key={index}
                        >
                          <CustomImage
                            imageUrl={getTemplateImage(item?.square)}
                            imgClass="aspect-square w-[15.9%] cursor-pointer"
                            loaderClass="aspect-square w-[15.9%]"
                            loaderStyle={{ background: '#5A5A5A50' }}
                            imgAlt={'square Img'}
                            errorPlaceholder={SquareDummyImg}
                            onClickRedirect={() => customNavigate('DIRECT', getLink(item), isEdit)}
                          />
                          <div style={{ width: '80%' }}>
                            <p
                              style={{
                                background: getStyleValue(
                                  'content_section',
                                  'content_title_bg',
                                  '#d6ff05',
                                ),
                                color: getStyleValue('content_section', 'content_title', '#d6ff05'),
                                padding: '2px 11px 2px 11px',
                              }}
                              className="cursor-pointer text-xs font-semibold line-clamp-1 w-fit mb-0"
                              onClick={() => customNavigate('DIRECT', getLink(item), isEdit)}
                            >
                              {item.title}
                            </p>
                            <p
                              style={{
                                color: getStyleValue(
                                  'content_section',
                                  'content_description',
                                  '#d6d6d6',
                                ),
                              }}
                              className="mb-0 text-[11px] mt-2 xl:mt-4 line-clamp-2"
                            >
                              {item?.description}
                            </p>
                          </div>
                        </div>
                      )
                    })
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(VerticalStreamDeck)
